module.exports = __webpack_public_path__ + "fonts/Pretendard-Thin.5940874a.woff";